module.exports = __webpack_public_path__ + "img/drone.a9a663ce.jpg";